import { render, staticRenderFns } from "./ConfigUserClient.vue?vue&type=template&id=2a9e6856&scoped=true"
import script from "./ConfigUserClient.vue?vue&type=script&lang=js"
export * from "./ConfigUserClient.vue?vue&type=script&lang=js"
import style0 from "./ConfigUserClient.vue?vue&type=style&index=0&id=2a9e6856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e6856",
  null
  
)

export default component.exports